<script lang="ts">
    import Emoji from '../Emoji.svelte';
    import Text from '../Text.svelte';
    import Color from 'color';

    // Utils
    import { getBorderRadius } from '$lib/global/helper/border-radius';
    import {
        isGradientColor,
        darkenGradientColor,
    } from '$lib/components/_DisplayComponents/_utils/color';

    // Types
    import type { Box as BoxType } from '$lib/types/Components/SharedTypes';
    import type { RawDraftContentState } from 'draft-js';

    export let id = '';
    export let link = '';
    export let draft: RawDraftContentState;
    export let emoji = ':smiley:';
    export let showIcon = true;
    export let color = 'black';
    export let bgColor = 'transparent';
    export let resultId = '';
    export let onClick: (resultId: string, id: string, link: string) => void;
    export let onMouseEnter: (resultId: string, id: string, link: string) => void;

    const handleClick = () => {
        onClick(resultId, id, link);
    };

    const handleMouseEnter = () => {
        onMouseEnter(resultId, id, link);
    };

    const textBox: BoxType = {
        top: 'none',
        bottom: 'none',
        left: 'none',
        right: 'none',
        backgroundColor: 'transparent',
    };

    const isGradient = isGradientColor(bgColor);

    $: bgColorDark = isGradient ? darkenGradientColor(bgColor, 0.1) : Color(bgColor).darken(0.1);

    const choiceItemBorderRadiusClass = getBorderRadius('choiceItem');
</script>

<div
    class={`${choiceItemBorderRadiusClass} wrapper box-border flex h-full min-h-[64px] w-full transform cursor-pointer select-none items-center overflow-hidden p-4 transition active:scale-90`}
    on:click={handleClick}
    on:mouseenter={handleMouseEnter}
    on:touchstart={handleMouseEnter}
    style="--answerBgColor: {bgColor}; --answerBgColorDark: {bgColorDark}"
>
    {#if showIcon}
        <div class="pr-[18px]">
            <Emoji {emoji} size="20px" />
        </div>
    {/if}
    <div class="flex-grow">
        <Text raw={draft} {color} box={textBox} />
    </div>
</div>

<style lang="scss">
    .wrapper {
        box-shadow:
            0 1px 3px rgba(0, 0, 0, 0.1),
            inset 0 0 1px 1px rgba(0, 0, 0, 0.1);
        background: var(--answerBgColor);

        &:hover,
        &:active {
            background: var(--answerBgColorDark);
        }
    }
</style>
